var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrderArrow = function SvgOrderArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 16,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 15,
    x: 1,
    y: 0.5,
    stroke: "#EFF0FA",
    rx: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#191C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.5 8h8M12.5 4.446 16.5 8l-4 3.556"
  })));
};
export { SvgOrderArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyNSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMSIgeT0iMC41IiB3aWR0aD0iMjMiIGhlaWdodD0iMTUiIHJ4PSI3LjUiIHN0cm9rZT0iI0VGRjBGQSIvPgo8cGF0aCBkPSJNOC41IDhMMTYuNSA4IiBzdHJva2U9IiMxOTFDMUUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTIuNSA0LjQ0NTUzTDE2LjUgOC4wMDEwOUwxMi41IDExLjU1NjYiIHN0cm9rZT0iIzE5MUMxRSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";